module.exports = "<p>This is the BRCA Exchange Summary View. Clinical significance for variants, where denoted, is from expert review by the ENIGMA consortium. Additional variant review is ongoing.</p>";


//////////////////
// WEBPACK FOOTER
// ./content/variantsDefault.md
// module id = 1286
// module chunks = 0